import Avatar from "../../../../Atoms/Avatar";
import { Location } from "../../../../../graphql/operations";
import s from "./DefaultGuide.module.css";

type DefaultGuideProps = {
  locationName: Location["translation"]["name"];
};

export default function DefaultGuide({ locationName }: DefaultGuideProps) {
  return (
    <div className={s.GuideListContainer}>
      <div className={s.GuideList}>
        {["jqxx6jcdz92fz1h8ry00", "sspnvsnxyppzumjbcze3"].map((imgId) => (
          <Avatar key={imgId} size={88} src={`guides/default/${imgId}`} />
        ))}
      </div>
      <div>
        It&apos;s available!
        <br />
        One of our {locationName} guides will be your guide!
      </div>
    </div>
  );
}
